import { useMutation } from '@apollo/react-hooks'
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonPage,
  IonTextarea,
  IonTitle,
  IonToast,
  IonToolbar
} from '@ionic/react'
import React, { useState } from 'react'
import { RouteComponentProps } from "react-router"
import Note from "../components/note"
import { CONTACT_MUTATION, ContactData, ContactVariables } from '../graphql/mutation/contact'

type Props = RouteComponentProps<{id: string}>

const Contact: React.FC<Props> = (props) => {
  const [toast, setToast] = useState<string>('');
  const [showLoading, setShowLoading] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [note, setNote] = useState('');

  const [send] = useMutation<ContactData, ContactVariables>(CONTACT_MUTATION)

  const [done, setDone] = useState(false);

  const confirm = async () => {
    if (
      !firstName
      || !lastName
      || !email
      || !phone
      || !email.match(/.*@.*\.[a-z]+/i)
    ) {
      setToast('Bitte Name, Email und Telefon angeben!')
      return;
    }

    setShowLoading(true);

    try {
      await send({
        variables: {
          code: props.match.params.id,
          contact: {
            firstName,
            lastName,
            email,
            phone,
            note,
          }
        }
      })

      setDone(true);
    } catch (e) {
      setToast('Bitte später erneut versuchen')
    }

    setShowLoading(false);
  }

  let content;

  if (done) {
    content = (
      <IonContent className="ion-padding">
        <Note>
          Wir haben ihre Daten erhalten
          <br />
          <p style={{
            color: 'rgba(0,0,0,0.5)',
            fontStyle: 'italic',
            fontSize: '80%'
          }}>
            Ein Mitarbeiter von uns wird sich bei ihnen melden.
          </p>
        </Note>

        <IonButton
          color="medium"
          fill={'outline'}
          expand={'block'}
          onClick={() => props.history.push({ pathname: '/home' })}
          style={{
            marginTop: 40,
          }}
        >gehe zur Homepage</IonButton>
      </IonContent>
    );
  } else {
    content = (
      <IonContent className="ion-padding">
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Verarbeite...'}
        />
        <IonToast
          isOpen={Boolean(toast)}
          color={'warning'}
          onDidDismiss={() => setToast('')}
          message={toast}
          duration={1500}
        />


        <Note>
          Wir benötigen Informationen um sie zu Kontaktieren.
          <br />
          <p style={{
            color: 'rgba(0,0,0,0.5)',
            fontStyle: 'italic',
            fontSize: '80%'
          }}>
            Die angegebenen Daten werden lediglich für Kontaktzwecke verwendet.
          </p>
        </Note>

        <IonItemGroup>
          <IonItemDivider>
            <IonLabel>Angaben zur Person</IonLabel>
          </IonItemDivider>
          <IonItem>
            <IonLabel position="floating">Vorname</IonLabel>
            <IonInput required value={firstName} onIonChange={e => setFirstName((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Nachname</IonLabel>
            <IonInput required value={lastName} onIonChange={e => setLastName((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">E-Mail</IonLabel>
            <IonInput required type={'email'} value={email} onIonChange={e => setEmail((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Telefon</IonLabel>
            <IonInput required type={'tel'} value={phone} onIonChange={e => setPhone((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Anmerkungen</IonLabel>
            <IonTextarea value={note} onIonChange={e => setNote((e.target as HTMLInputElement).value)} />
          </IonItem>
        </IonItemGroup>

        <Note>
          Ein Mitarbeiter meldet sich nach der Bestätigung bei ihnen
        </Note>

        <IonButton color="primary" expand={'block'} onClick={confirm}>Ich will eine Umfassende Beratung</IonButton>
      </IonContent>
    );
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>Umfassende Beratung</IonTitle>
        </IonToolbar>
      </IonHeader>

      {content}
    </IonPage>
  );
};

export default Contact;

